"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InxsRuleType = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var InxsRuleType;
(function (InxsRuleType) {
    InxsRuleType["Include"] = "INCLUDE";
    InxsRuleType["Exclude"] = "EXCLUDE";
    InxsRuleType["None"] = "NONE";
})(InxsRuleType = exports.InxsRuleType || (exports.InxsRuleType = {}));
